import tw, { styled } from 'twin.macro';
import { Body } from './Typography';

/**
 * The Label styled component represents the standard html element `<label />`.
 * This component gives the ability to have the label rendered in the desired textstyle.
 */

export default styled(Body).attrs(({ $forInput }) => ({
  htmlFor: $forInput,
  as: 'label'
}))(() => [tw`block font-bold`]);
